module.exports = __webpack_public_path__ + "static/media/aurient_logo.dda88efa.svg";